var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardChatMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2047_15305",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2047_15305",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAWVJREFUaEPtmTFOQzEMhr9eBw4AKxMcgZWZAYmJEbauSMysXAE2Vg4A1wFFKpJb5TVx4ih+krM8qY2d//OfWK/phpWPzcr1EwCzHVxy4Ax4BtLTw/gC7oD03Bs5gBPg24PqjIZT4Ed+ngN4By6dAnwAVyWAXzHByyFf1JQTGAADtl84MKCoqpSmDshkKhWVk1XnUjV5JyAACk6oiqqaXLkFRkwzPQMjBJZyBoCs0GOpXJ3f5/KbOhBdaHYXWv0W6tziTeGmZ6BJQWdQAMgC9nShT+CiwQ1TBwJgtgMN63eHmG6hbjUNCQKgoWimIeFAKucbcG1aV32ydLl7LsNqf1K+Ajf69cwjkvi9G+oagBfg1lyKLmG61L0/vJlOKUoAW+BBrPUEjH6dVqGVAGQyd+JrHPgHcCm+FsCt+BoA1+JLAO7FHwNYhfglgNQmXbXKY33Vy594qt5fepVoTjYjMByYUXW55h8RJWIxFKZCiAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardChatMsg);
export default __webpack_public_path__ + "static/media/DashboardChatMsg.77658b91d72f9d08e1ffc2007bcff2ed.svg";
export { ForwardRef as ReactComponent };